module.exports = __webpack_public_path__ + "img/27.8cd5a02d.jpg";